import { createFileRoute } from '@tanstack/react-router'
import { NotificationsSettingsPage } from '@/features/notifications/components/NotificationsSettingsPage'

export const Route = createFileRoute('/_authed/settings/notifications')({
  component: NotificationsRoute,
})

function NotificationsRoute() {
  return <NotificationsSettingsPage />
}
